import React, {useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import {FaTrashAlt} from 'react-icons/fa';
import {addItem, removeItem} from '../redux/cart/cartActions';
import {useDispatch} from 'react-redux';

const CartItem = ({item}) => {

    const [qty, setQty] = useState(item.qty);
    const dispatch = useDispatch();

    const addHandler = () =>{
        const newItem = {product : item.product, qty};
        dispatch(addItem(newItem));
    }

    useEffect(() =>{
        addHandler();
    },[qty])
    
  return (
    <div className="cart-item">
        <Link className="nav product-details" to={`/product/${item.product._id}`}>
            <img src={item.product.image} alt={item.product.name}/>
            {item.product.name}
        </Link>

        Qty : <select value={qty}
                    onChange={(e) => setQty(e.target.value)}>
                        {[...Array(item.product.countInStock).keys()].map(
                              (x) => (
                                <option key={x + 1} valsue={x + 1}>
                                  {x + 1}
                                </option>
                              )
                            )}
        </select>

        <div className="delete-icon" onClick={() => dispatch(removeItem(item))}><FaTrashAlt size={20}/></div>
    </div>
  )
}

export default CartItem